import axios from 'axios';
import UserAuthKey from '../../../components/Common/UserAuthKey';
import { setUserData } from '../../../Redux/user/userSlice';
import {
  setListLoading,
  setCodReturnOrders,
  setListError,
} from '../../../Redux/codReturnOrders/codReturnOrdersSlice';

const apiUrl = process.env.REACT_APP_OMS_API;

const authHeaders = () => ({
  Authorization: `Bearer ${UserAuthKey()}`,
  'Content-Type': 'application/json',
});

const isAuthError = (error, dispatch) => {
  if (error?.response?.status === 401) {
    if (dispatch) dispatch(setUserData(null));
    window.location.replace('/logout');
    return true;
  }
  return false;
};

/**
 * POST v1/orders/cod-return-list
 * body: { start, limit, page, per_page, search_qry, country, sort, orderBy }
 * response: rows under data / data.data, totals under pagination or recordsTotal
 */
export const fetchCodReturnOrders = async ({ params, dispatch }) => {
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/orders/cod-return-list`,
    headers: authHeaders(),
    data: { ...params },
  };
  try {
    dispatch(setListLoading(true));
    const response = await axios(config);
    dispatch(setCodReturnOrders(response?.data));
    return response.data;
  } catch (error) {
    if (!isAuthError(error, dispatch)) {
      dispatch(setListError(error?.response?.data?.message));
    }
    throw error;
  }
};

/**
 * POST v1/orders/mark-cod-return-paid
 * Record the decision on one COD return.
 * body: { queue_id, is_refund } - is_refund 1 = COD amount received
 * (approved), 2 = rejected.
 */
export const approveCodReturnOrder = async ({ params, dispatch }) => {
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/orders/mark-cod-return-paid`,
    headers: authHeaders(),
    data: { ...params },
  };
  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    if (!isAuthError(error, dispatch)) {
      throw error;
    }
  }
};
